const lan = {
  REDIRECT: "Omdirigerar...",
  RULE: {
    SERVICE_TYPE: "Välj tjänstetyp",
    COUNTRY: "Välj ditt land eller din region",
    USERNAME: "Ett användarnamn krävs",
    EMAIL: "En e-postadress krävs",
    EMAIL2: "Ange rätt e-postformat.",
    PRODUCT: "Välj din enhet",
    PRODUCTSN: "Ange din produkts serienummer",
    PRODUCTSN_LEN: "Ange 12 till 15 bokstäver eller siffror",
    BIRTHDAY: "En födelsedag krävs",
    REQUIRED: "Krävs",
  },
  SYS: {
    HEAD: "System",
    NOSERVICE:
      "Tyvärr, ASUS Chat är inte tillgängligt för ditt valda land eller område.",
    CHECK_FILESIZE:
      "Kontrollera storleken på bilden eller bilagan. Begränsning:",
    RECONNECTED: "Anslutningsstatusen har återgått till det normala",
    UNABLE_SEND: "Det går inte att skicka bilagorna",
    NO_NETWORK: "Ingen internetanslutning",
    NO_NETWORK_INFO:
      "Ingen internetanslutning. Anslut till internet och försök igen.",
  },
  IDLE: {
    HEAD: "Du har varit inaktiv ett tag. Vill du fortsätta chatten?",
    BUTTON: "Fortsätt",
  },
  DISCONNECT: {
    HEAD: "Chatten har avslutats",
    BUTTON: "Avsluta",
  },
  LAYOUT: {
    STEP_1: "Välj produkt",
    STEP_2: "Användarvillkor",
    STEP_3: "Logga in",
    STEP_4: "Information",
    SELECT_SKILL: "Välj produkt",
    PREV_STEP: "Föregående",
    NEXT_STEP: "Nästa",
    NOTSET: "Inte inställd.",
    AGREEN: "Godkänner",
    NOTAGREEN: "Godkänner inte",
    LEAVE: "Lämna",
    TYPE_HERE: "Skriv här",
    CHAT_DOWNLOAD:
      "Klicka här för att spara en kopia av din chatt med ASUS kundtjänst.",
  },
  COUNTRY: { SELECT_COUNTRY: "Vänligen välj tjänstens land eller region" },
  POLICY: {
    PRIVACY: "Integritetsskyddspolicy",
    SAT_SURVEY: "Serviceavtal",
    CONFIRM_COUNTRY: {
      H1: "Bästa ASUS-kund,",
      P1:
        "Du besöker nu ASUS Kundtjänst för Norden, som skiljer sig från din nuvarande region. Enligt ASUS garantivillkor är inte alla ASUS-produkter tillämpliga för ASUS internationella garanti- och supporttjänster. Om ovanstående regionala webbplats som du besöker inte är den region där du köpte din ASUS-produkt eller skiljer sig från din nuvarande region, kan detta påverka dina rättigheter. Du kan fortsätta använda ASUS onlinekundtjänst för Sverige eller ändra ASUS onlinekundtjänst till din region.",
      P2: "",
      P3: "",
      B1: "Byt till ASUS",
      B2: "Hemsida",
      B3: "Fortsätt att använda",
    },
    BULLETIN: {
      HEAD: "Notifikation om ett viktigt meddelande",
      CONFIRM: "Jag förstår",
    },
  },
  SURVEY: {
    SURVEY_ENTER: "Vänligen fyll i dina kontaktuppgifter",
    SURVEY_TYPE: "Vänligen välj tjänstetyp",
    PROBLEM_BRIEF: "Hur skulle du beskriva ditt problem?",
    TYPE1: "Generell fråga",
    TYPE2: "Reparationsförfrågan",
    TYPE3: "Teknisk support",
    TYPE4: "Garantiförfrågan",
    TYPE5: "Åsikter och feedback",
    EC_TYPE1: "Produkt- och försäljningsinformation",
    EC_TYPE2: "Marknadsföringsevenemang",
    EC_TYPE3: "Leverans- och orderstatus",
    EC_TYPE4: "Returservice",
    SIGNUPDATA: "Din registreringsinformation",
    NAME: "Namn",
    TEL: "Telefonnummer",
    ORDER_NO: "Ordernr.",
    BIRTHDAY: "Födelsedag",
    LABEL_EMAIL: "E-post",
    EMAIL: "E-post",
    DEVICEINFO: "Din produktinformation",
    DEVICENAME: "Produktnamn",
    MY_DEVICE: "Din produkt",
    MY_DEVICE_SELECT: "Välj din produkt",
    MY_DEVICE_EMPTY: "Du har inga enheter ännu.",
    LABEL_DEVICESN: "Serienummer",
    DEVICESN: "Produktens serienummer",
    DEVICESN_ERROR: "Serienumret du angav är ogiltigt.",
    PREPARE: "Skapar chattrummet, gör redo för chatt",
    START: "Starta chatten",
    AGE_LIMIT: "Åldersgräns",
    AGE_LIMIT_DESC: "Du uppfyller inte ålderskraven för att använda ASUS Chat",
    REPEAT_ENTRY: {
      H1: "Befintligt chattrum upptäckt",
      P1:
        "Är du säker på att du vill starta en ny konversation? När en ny konversation öppnas kommer den gamla konversationen att avslutas.",
      B0: "Bekräfta",
      B1: "Avbryt",
    },
  },
  CONNECTTING: {
    P1: "Vänta ett ögonblick och stäng inte chattfönstret",
    P2: "ASUS Chat ansluter dig till en tillgänglig agent",
    NOTE: "Tips",
    BEFORE_LEAVE: "Är du säker på att du vill avsluta din ASUS Chat?",
    B0: "Avsluta",
    B1: "Stanna kvar och vänta",
  },
  OFFLIEN: {
    OTHER_CONTACT: "Kontakta ASUS via andra kanaler",
    MAIL: "E-posta oss",
    TEL: "Ring oss",
    CLOSE: "Stäng",
  },
  WAITTING: {
    WATTING_NUM: "Position i kön",
    PEOPLE: "Kund",
    NOTE: "Tips",
    BEFORE_LEAVEL: "Är du säker på att du vill lämna kön?",
    LEAVE_DESC: "Om du vill lämna kön kan du avsluta chatten",
    LEAVE: "Avsluta chatten",
    STAY: "Stanna i kön",
  },
  CHATROOM: {
    TYPING: "Agenten skriver...",
    HEAD: {
      CLOSE_AMD_SURVEY: "Lämna chatten",
      TERMINATE: "Avsluta chatten",
    },
    FOOTER: { CHAT_FINISH: "Chatten har avslutats" },
    FINISH:
      "Chatten har avslutats. Behöver du ytterligare service eller support?",
    SAT_SURVEY: {
      SAT: "Nöjd",
      DISSAT: "Missnöjd",
      SAT_CHOOSE: "Vilken typ av tjänster? (flera)",
      HEAD: "Var du nöjd med chatten?",
      DESC:
        "Att lyssna på din feedback är en drivkraft för vår kontinuerliga förbättring. Låt oss veta om du har några förslag på ASUS Service eller Support.",
      OTHER_OPTION: "Annat",
      OTHER_REASON: "Vänligen fyll i den andra orsaken",
      SEND: "Skicka",
    },
    CLOSE: {
      TITLE: "Är du säker på att du vill avsluta chatten?",
      P1:
        'Klicka på "Avsluta" för att stänga fönstret. Om du behöver använda chatten igen, klicka på "Starta ny chatt".',
      B0: "Avsluta",
      B1: "Avbryt",
    },
  },
  ERROR: {
    H1: "Chattrummet finns inte eller chatten har redan avslutats",
    CLOSE: "Stäng fönstret",
  },
  CHAT_END: {
    H1: "Tack så mycket, chatten har nu avslutats",
    CLOSE: "Stäng fönstret",
  },
  CHAT_CLOSE: {
    H1:
      "Din nätverksanslutning har varit nere i mer än 300 sekunder, så vi har avslutat denna konversation.",
    DESC:
      "Om du använder ett trådlöst eller mobilt nätverk, vänligen flytta dig till en plats med en starkare signal; eller byt till en trådbunden nätverksanslutning. Vi ber om ursäkt för eventuella besvär",
    CLOSE: "Stäng fönstret",
  },
  SURVEY_DONE: {
    H1: "Tack. Du har slutfört undersökningen om servicetillfredsställelse",
    P1:
      'Din feedback är en drivkraft för vår kontinuerliga förbättring. Tack för att du tog dig tid att fylla i undersökningen om servicetillfredsställelse. Om du behöver ytterligare service eller support, klicka på "Starta ny chatt". Klicka på "Stäng fönstret" för att avsluta chatten om vi har löst ditt problem',
    AGAIN: "Starta ny chatt",
    CLOSE: "Stäng fönstret",
    YT_H1: "Upptäck tips och teknisk kunskap med ASUS supportvideor.",
    YT_H2: "Klicka för att utforska!",
  },
  AGENT_OFFLINE: {
    H1:
      "Agentens internetanslutning svarar inte; din chatt är för närvarande avbruten",
    H2:
      "Stäng inte fönstret; vi arbetar hårt för att återuppta chatten",
    DESC:
      'Du kan också välja att avsluta chatten och påbörja undersökningen eller klicka på "Starta ny chatt", så kommer vi omedelbart att tilldela en ny agent för att fortsätta din chatt. Vi ber om ursäkt för eventuella besvär',
    AGAIN: "Starta ny chatt",
  },
  VIDEOCALL: {
    MEDIA_NOTALLOW: "Det går inte att använda kamera och mikrofon",
    H1: "Redo att ansluta?",
    P1:
      "För att ASUS kundtjänstpersonal ska kunna hjälpa dig att lösa problemet mer effektivt måste du tillåta enheten att komma åt din kamera och mikrofon för att ansluta till videochattrummet, och se till att din mobila nätverksanslutning är stabil och fungerar normalt",
    P2:
      "Efter åtkomst kan du fortfarande fritt ställa in linsomkopplaren och mikrofonens ljud av.",
    VIDEO_STATE: "Videostatus",
    VIDEO_ON: "På",
    VIDEO_OFF: "Av",
    AUDIO_STATE: "Ljudstatus",
    AUDIO_ON: "På",
    AUDIO_OFF: "Av",
    ENTER: "Anslut",
    HANGUP: {
      H1: "Lägg på",
      P1: "Är du säker på att du vill lägga på videochatten?",
      CONFIRM: "Bekräfta",
      CANCEL: "Avbryt",
    },
    END: {
      H1: "Videosamtalet har avslutats",
      P1: "Tack, detta videosamtal är över, du kan stänga detta fönster.",
    },
  },
  GPT: {
    LAYOUT: {
      STEP_1: "Välj produkt",
      STEP_2: "Användarvillkor",
      STEP_3: "Logga in",
      STEP_4: "Information",
      SELECT_SKILL: "Välj produkt",
      WELCOME: "Välkommen",
      AGREE: "Godkänn",
      START: "Starta",
      CANCEL: "Avbryt",
      WAIT: "Vänta",
      INPUT: "Skriv din fråga här",
      TRANSFER_TOAGENT: "Vidarebefordra till agent.",
      READMORE: "Du kan också hänvisa till följande relaterade FAQ, tack.",
      COLLAPSE: "Dölj",
      INPUT_SN: "Vänligen ange serienumret igen",
      YOU_MAY_ALSO: "Du kanske också vill fråga:",
      FOR_FURTHER: "För mer information, se:",
      RECORDING: "Vänligen börja tala...",
      RECORDING_NOT_SUPPORTED:
        "Din webbläsare stöder inte taligenkänning",
      RECORDING_NOT_FOUND:
        "Ingen inspelningsenhet upptäcktes. Kontrollera din mikrofon och behörigheter.",
    },
    IS_COMPONENT_SN:
      "Inmatningen är komponentens serienummer, du bör ange rätt maskinserienummer.",
    WARRANTY: {
      SERIES: "Produkttyp",
      MODEL: "Produktnamn",
      SERIALNO: "Produktens serienummer",
      STATUS: "Garantistatus",
      DATE: "Garantins utgångsdatum",
    },
    HEAD: {
      LEAVE: "Lämna",
      CREATE_NEW: "Börja om",
    },
    ENTRANCE: {
      POLICY: "Integritetspolicy",
      AGREE: "Klicka på Godkänn för att starta konversationen",
    },
    MESSAGE: {
      WAIT: "Vänta, vi letar efter en lösning åt dig.",
    },
    END: "Konversationen avslutad",
    END_MSG:
      "Vi är glada att kunna erbjuda vår service. Tveka inte att kontakta oss för framtida support.",
    END_SURVEY: "Nöjdhetsundersökning",
    END_SURVEY_MSG:
      "Vi är glada att kunna erbjuda vår service. Tveka inte att kontakta oss för framtida support.",
    BACKHOME: "Starta om konversationen",
    SURVEY: {
      DESC: "Vänligen betygsätt din upplevelse med ASUS virtuella assistent.",
      SAT: "Nöjd",
      DISSAT: "Missnöjd",
      FEEDBACK: "Vänligen fyll i din feedback.",
      SEND: "Skicka",
      BACK: "Avbryt",
    },
    SURVEY_DISLIKE: {
      H1: "Varför är du missnöjd med svaret?",
      P: "Din feedback hjälper oss att förbättra vår servicekvalitet.",
      BUTTON: "Skicka",
    },
    HISTORY: {
      TITLE: "Historik",
      AGO: "{hours} timmar sedan",
      CONTINUE: "Fortsätt chatten",
      CLOSE: "Konversationen har avslutats.",
      RESTART: "Starta om med virtuell assistent",
      NON_SERVICE: "Ej servicetid",
      VIEW_HISTORY: "Klicka för att visa den senaste chatthistoriken.",
    },
  },
};
export default lan;
